import React, { useEffect, useState, useCallback } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  Loading,
  AccessTemplateSelect
} from "../common/APICommon";
import { apiUrl } from "../utils/Configuration";
import NoAccess from "./NoAccess";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import GroupIcon from '@mui/icons-material/Group';
import KeyIcon from '@mui/icons-material/Key';

export default function Users() {
//#region Others
  const [activeTab, setActiveTab] = useState("users");

  const tabs = [
    { key: "users", label: "Users" },
    { key: "access", label: "Access Templates" },
  ];
//#endregion





//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasUsers) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        <div className="flex border-b border-gray-200 mb-6 space-x-1 sm:space-x-4  z-10">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`py-2 px-3 sm:px-4 text-sm font-medium transition-colors duration-150 focus:outline-none ${
                activeTab === tab.key
                  ? "text-theme-color border-b-2 border-theme-color"
                  : "text-gray-500 hover:text-theme-color"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        
        {activeTab === "users" &&
          <MainUsers />
        }
        
        {activeTab === "access" &&
          <AccessTemplates />
        }
      </div>
    </>
  );
//#endregion
}










//#region Main Users
function MainUsers() {








//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.username.toLowerCase().includes(lowerValue) ||
        item.id.toString().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion




//#region Variables
  const [selectedData, setSelectedData] = useState(null);
  const [accessTemplate, setAccessTemplate] = useState(null);
  const [accountId, setAccountId] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const resetVariables = () => {
    setAccessTemplate(null);
    setAccountId(null);
    setUsername("");
    setPassword("");
    setSelectedData(null);
  }
//#endregion




// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  const handleAddData = async () => {
    const data = {
      accountId: accountId,
      accessTemplateId: accessTemplate?.id,
      username: username,
      password: password,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/User`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion




// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const editHandleClick = (data) => {
    setSelectedData(data);

    setAccessTemplate(data.accessTemplate);
    setAccountId(data.accountId);
    setUsername(data.username);

    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const data = {
      accountId: accountId,
      accessTemplateId: accessTemplate?.id,
      username: username,
      password: password,
    };

    try {
      setLoading(true);

      await axios.put(`${apiUrl}/api/User/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion




//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'ID', 
    'USERNAME', 
    'ACCESS', 
    'ACTIONS',
  ]
  const accessors = [
    'id', 
    'username', 
    'accessTemplateDescription', 
    'actions'
  ]

  const actions = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/User` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData])
//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasUsers) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <GroupIcon fontSize="large" className="text-theme-color" />
              {`Users (${data?.length ?? 0})`}
            </h2>
            <p className="text-gray-500 mt-1">List of user accounts.</p>
          </div>
          <div className="flex gap-3">
            <button onClick={openAddForm} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New User
            </button>
          </div>
        </div>

        {/* Search and Filters */}
        <div className="flex justify-between items-center gap-2">
          <div className="mb-4 w-full">
            <input
              type="text"
              placeholder="Search by username or ID..."
              className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
            {/* Add filter dropdowns here if needed */}
          </div>
        </div>

        <CreateTable
          tableName={"User"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <RegisterUserModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Data"}

        data={data}
        accountId={accountId} setAccountId={setAccountId}
        accessTemplate={accessTemplate} setAccessTemplate={setAccessTemplate}
        username={username} setUsername={setUsername}
        password={password} setPassword={setPassword}
      />

      <UpdateUserModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Data"}

        data={data}
        accountId={accountId} setAccountId={setAccountId}
        accessTemplate={accessTemplate} setAccessTemplate={setAccessTemplate}
        username={username} setUsername={setUsername}
        password={password} setPassword={setPassword}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}







const RegisterUserModal = ({
  visible, onClose, onSave, modalName,
  data,
  accessTemplate, setAccessTemplate,
  accountId, setAccountId,
  username, setUsername,
  password, setPassword,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  if (!visible) return null;

  const handleSubmit = async () => {
    if (!accessTemplate || !username || !password) {
      setFailMessage("Please fill up required field/s.");
      return;
    }

    if(confirmPassword !== password){
      setFailMessage("Password doesn't match.");
      return;
    }
    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
    setConfirmPassword("")
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Username <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Username"
                    className="w-full border border-gray-300  rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Password <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="password"
                    placeholder="Password"
                    className="w-full border border-gray-300  rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Confirm Password <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="password"
                    placeholder="Confirm Password"
                    className="w-full border border-gray-300  rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Account Id
                  </label>
                  <input
                    type="text"
                    placeholder="Account Id"
                    className="w-full border border-gray-300  rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                    value={accountId}
                    onChange={(e) => setAccountId(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Access Template <span className="text-red-500">*</span>
                  </label>
                  <AccessTemplateSelect data={accessTemplate} setData={setAccessTemplate} isEditable={true}/>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const UpdateUserModal = ({
  visible, onClose, onSave, modalName,
  data,
  accessTemplate, setAccessTemplate,
  accountId, setAccountId,
  username, setUsername,
  password, setPassword,
}) => {
  const [failMessage, setFailMessage] = useState("");

  if (!visible) return null;

  const handleSubmit = async () => {
    if (!accessTemplate || !username) {
      setFailMessage("Please fill up required field/s.");
      return;
    }
    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Username <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Username"
                    className="w-full border border-gray-300  rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Account Id
                  </label>
                  <input
                    type="text"
                    placeholder="Account Id"
                    className="w-full border border-gray-300  rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                    value={accountId}
                    onChange={(e) => setAccountId(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Access Template <span className="text-red-500">*</span>
                  </label>
                  <AccessTemplateSelect data={accessTemplate} setData={setAccessTemplate} isEditable={true}/>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion











//#region Access Templates
const initialAccessTemplateForm = {
  description: "",
  isActive: true,
  hasDashboard: false,
  hasReceivables: false,
  hasPayables: false,
  hasBank: false,
  hasCheckbook: false,
  hasChartOfAccounts: false,
  hasAccountTypes: false,
  hasPostingKeys: false,
  hasJournals: false,
  hasCustomers: false,
  hasVendors: false,
  hasBillingType: false,
  hasBusinessArea: false,
  hasCompany: false,
  hasConversion: false,
  hasCreditTerm: false,
  hasDocumentType: false,
  hasPaymentMethod: false,
  hasTaxationCode: false,
  hasItems: false,
  hasProduction: false,
  hasUsers: false,
  hasBankReconciliation: false,
  hasCheckVoucher: false,
  hasCustomerLedger: false,
  hasDeliveryReport: false,
  hasFinancialStatement: false,
  hasJournalVoucher: false,
  // hasOtherPayableVoucherForServices: false,
  hasOutgoingPaymentVoucher: false,
  hasStatementOfAccount: false,
  hasVendorLedger: false,
  hasWorkingTrialBalance: false,
  hasPurchaseOrderReport: false,
  hasSalesOrderReport: false,
  hasProductionReport: false,
  hasGeneralLedgerReport: false,
  hasCollectionReport: false,
  hasSettings: false,
  hasGetHelp: false,
};
function AccessTemplates() {








//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.description.toLowerCase().includes(lowerValue) ||
        item.id.toString().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion




//#region Variables
  const [selectedData, setSelectedData] = useState(null);
  const [form, setForm] = useState(initialAccessTemplateForm);

  const resetVariables = () => {
    setForm(initialAccessTemplateForm);

    setSelectedData(null);
  }
//#endregion




// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  const handleAddData = async () => {
    const data = { 
      ...form, 
      createdBy: accountData?.id, 
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/AccessTemplate`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion




// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const editHandleClick = (data) => {
    setSelectedData(data);
    setForm({ ...data });

    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const data = { 
      ...form, 
      updatedBy: accountData?.id, 
    };

    try {
      setLoading(true);

      await axios.put(`${apiUrl}/api/AccessTemplate/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion




//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'ID', 
    'DESCRIPTION', 
    'STATUS', 
    'ACTIONS',
  ]
  const accessors = [
    'id', 
    'description', 
    'isActive', 
    'actions'
  ]

  const actions = [
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiUrl}/api/AccessTemplate` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData])
//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasUsers) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <KeyIcon fontSize="large" className="text-theme-color" />
              {`Access Templates (${data?.length ?? 0})`}
            </h2>
            <p className="text-gray-500 mt-1">List of access templates for users.</p>
          </div>
          <div className="flex gap-3">
            <button onClick={openAddForm} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New Template
            </button>
          </div>
        </div>

        {/* Search and Filters */}
        <div className="flex justify-between items-center gap-2">
          <div className="mb-4 w-full">
            <input
              type="text"
              placeholder="Search by description or ID..."
              className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
            {/* Add filter dropdowns here if needed */}
          </div>
        </div>

        <CreateTable
          tableName={"Access Template"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <AddUpdateModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Data"}

        data={data}
        form={form} setForm={setForm}
      />

      <AddUpdateModal 
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Data"}

        data={data}
        form={form} setForm={setForm}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}














//#region AddUpdate Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  data,
  form, setForm,
}) => {
  const [failMessage, setFailMessage] = useState("");

  if (!visible) return null;

  const handleSubmit = async () => {
    if (!form?.description) {
      setFailMessage("Please fill up required field/s.");
      return;
    }
    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

  const dashboard = [
    {
      name: "Dashboard",
      value: "hasDashboard",
    }
  ]
  const receivables = [
    {
      name: "Receivables",
      value: "hasReceivables",
    },
  ]
  const payables = [
    {
      name: "Payables",
      value: "hasPayables",
    },
  ]
  const accounts = [
    {
      name: "Chart of Accounts",
      value: "hasChartOfAccounts",
    },
    {
      name: "Account Types",
      value: "hasAccountTypes",
    },
    {
      name: "Bank",
      value: "hasBank",
    },
    {
      name: "Checkbook",
      value: "hasCheckbook",
    },
    {
      name: "Posting Keys",
      value: "hasPostingKeys",
    },
    {
      name: "Journals",
      value: "hasJournals",
    },
  ]
  const partners = [
    {
      name: "Customers",
      value: "hasCustomers",
    },
    {
      name: "Vendors",
      value: "hasVendors",
    },
  ]
  const maintenance = [
    {
      name: "Billing Type",
      value: "hasBillingType",
    },
    {
      name: "Business Area",
      value: "hasBusinessArea",
    },
    {
      name: "Company",
      value: "hasCompany",
    },
    {
      name: "Conversion",
      value: "hasConversion",
    },
    {
      name: "Credit Term",
      value: "hasCreditTerm",
    },
    {
      name: "Document Type",
      value: "hasDocumentType",
    },
    {
      name: "Payment Method",
      value: "hasPaymentMethod",
    },
    {
      name: "Taxation Code",
      value: "hasTaxationCode",
    },
  ]
  const reports = [
    {
      name: "Bank Reconciliation",
      value: "hasBankReconciliation",
    },
    {
      name: "Check Voucher",
      value: "hasCheckVoucher",
    },
    {
      name: "Collection Report",
      value: "hasCollectionReport",
    },
    {
      name: "Customer Ledger",
      value: "hasCustomerLedger",
    },
    {
      name: "Delivery Report",
      value: "hasDeliveryReport",
    },
    {
      name: "Financial Statement",
      value: "hasFinancialStatement",
    },
    {
      name: "General Ledger Report",
      value: "hasGeneralLedgerReport",
    },
    {
      name: "Journal Voucher",
      value: "hasJournalVoucher",
    },
    /* {
      name: "Other Payable Voucher for Services",
      value: "hasOtherPayableVoucherForServices",
    }, */
    {
      name: "Outgoing Payment Voucher",
      value: "hasOutgoingPaymentVoucher",
    },
    {
      name: "Production Report",
      value: "hasProductionReport",
    },
    {
      name: "Purchase Order Report",
      value: "hasPurchaseOrderReport",
    },
    {
      name: "Purchase Register",
      value: "hasPurchaseRegister",
    },
    {
      name: "Sales Order Report",
      value: "hasSalesOrderReport",
    },
    {
      name: "Sales Register",
      value: "hasSalesRegister",
    },
    {
      name: "Statement of Account",
      value: "hasStatementOfAccount",
    },
    {
      name: "Vendor Ledger",
      value: "hasVendorLedger",
    },
    {
      name: "Working Trial Balance",
      value: "hasWorkingTrialBalance",
    },
  ]
  const items = [
    {
      name: "Items",
      value: "hasItems",
    },
  ]
  const production = [
    {
      name: "Production",
      value: "hasProduction",
    },
  ]
  const users = [
    {
      name: "Users",
      value: "hasUsers",
    },
  ]
  const settings = [
    {
      name: "Settings",
      value: "hasSettings",
    },
  ]
  const getHelp = [
    {
      name: "Get Help",
      value: "hasGetHelp",
    },
  ]

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700 ">
                    Description <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="e.g. Admin"
                    className="w-full border border-gray-300  rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                    value={form?.description}
                    onChange={(e) => setForm((prev) => ({ ...prev, description: e.target.value }))}
                  />
                </div>

                <div className="flex items-center justify-between border border-gray-300 rounded-lg p-3 bg-white">
                  <span className="text-sm font-medium text-gray-700">
                    Active Status
                  </span>
                  <button
                    type="button"
                    onClick={() =>
                      setForm((prev) => ({ ...prev, isActive: !prev.isActive }))
                    }
                    className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 focus:outline-none ${
                      form?.isActive ? "bg-theme-color" : "bg-gray-400"
                    }`}
                  >
                    <span
                      className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
                        form?.isActive ? "translate-x-7" : "translate-x-1"
                      }`}
                    />
                  </button>
                </div>

                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Dashboard"} accessItems={dashboard}
                />
                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Receivables"} accessItems={receivables}
                />
                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Payables"} accessItems={payables}
                />
                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Accounts"} accessItems={accounts}
                />
                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Partners"} accessItems={partners}
                />
                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Maintenance"} accessItems={maintenance}
                />
                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Users"} accessItems={users}
                />
                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Items"} accessItems={items}
                />
                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Production"} accessItems={production}
                />
                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Reports"} accessItems={reports}
                />
                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Settings"} accessItems={settings}
                />
                <CreateAccessTemplateInput 
                  form={form} setForm={setForm}
                  parentName={"Get Help"} accessItems={getHelp}
                />
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};





const CreateAccessTemplateInput = ({
  form, setForm,
  parentName, accessItems
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 bg-gray-300 p-2 rounded-sm">
        {parentName}
      </label>
      <div className="flex flex-row justify-between p-2">
        <div className="w-full">
          <div className="flex flex-col">
            <label className="block text-sm font-medium mb-1 text-gray-700">
              Access Item
            </label>
            {/* Items */}
            <div className="flex flex-col gap-2">
              { accessItems.map((item, index) => {
                return (
                  <div key={index} className="flex flex-row gap-1">
                    <input
                      key={index}
                      type="checkbox"
                      checked={form?.[item.value] ?? false}
                      onChange={(e) =>
                        setForm(prev => ({
                          ...prev,
                          [item.value]: e.target.checked,
                        }))
                      }
                    />
                    <label className="block text-sm text-gray-700">
                      {item?.name}
                    </label>
                  </div>
                )})
              }
            </div>
          </div>
        </div>
        <div className="flex flex-row items-center justify-between w-full">
          <div className="flex-col hidden">
            <label className="block text-sm font-medium mb-1 text-gray-700">
              Create
            </label>
            <div className="flex flex-col gap-2">
              { accessItems.map((item, index) => {
                return (
                  <input
                    key={index}
                    type="checkbox"
                    checked={form?.[item.create] ?? false}
                    className="my-1"
                    onChange={(e) =>
                      setForm(prev => ({
                        ...prev,
                        [item.create]: e.target.checked,
                      }))
                    }
                  />
              )})}
            </div>
          </div>
          <div className="flex-col hidden">
            <label className="block text-sm font-medium mb-1 text-gray-700">
              Update
            </label>
            <div className="flex flex-col gap-2">
              { accessItems.map((item, index) => {
                return (
                  <input
                    key={index}
                    type="checkbox"
                    checked={form?.[item.update] ?? false}
                    className="my-1"
                    onChange={(e) =>
                      setForm(prev => ({
                        ...prev,
                        [item.update]: e.target.checked,
                      }))
                    }
                  />
              )})}
            </div>
          </div>
          <div className="flex-col hidden">
            <label className="block text-sm font-medium mb-1 text-gray-700">
              Delete
            </label>
            <div className="flex flex-col gap-2">
              { accessItems.map((item, index) => {
                return (
                  <input
                    key={index}
                    type="checkbox"
                    checked={form?.[item.delete] ?? false}
                    className="my-1"
                    onChange={(e) =>
                      setForm(prev => ({
                        ...prev,
                        [item.delete]: e.target.checked,
                      }))
                    }
                  />
              )})}
            </div>
          </div>
          <div className="flex-col hidden">
            <label className="block text-sm font-medium mb-1 text-gray-700">
              View
            </label>
            <div className="flex flex-col gap-2">
              { accessItems.map((item, index) => {
                return (
                  <input
                    key={index}
                    type="checkbox"
                    checked={form?.[item.view] ?? false}
                    className="my-1"
                    onChange={(e) =>
                      setForm(prev => ({
                        ...prev,
                        [item.view]: e.target.checked,
                      }))
                    }
                  />
              )})}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
//#endregion
//#endregion






